module.exports = __webpack_public_path__ + "img/holiday_unselect.77e6a82a.png";